
import { createServer } from 'miragejs'
import appConfig from 'configs/app.config'  

import { signInUserData } from './data/authData'

import { authFakeApi } from './fakeApi'

const { apiPrefix } = appConfig

export default function mockServer({ environment = 'test' }) {
    return createServer({
        environment,
        seeds(server) {
			server.db.loadData({
				signInUserData
			})
		},
        routes() {
            this.urlPrefix = ''
            this.namespace = ''
            
            // Allow external API calls to pass through
            this.passthrough('https://fakestoreapi.com/**')
            this.passthrough('http://**')
            this.passthrough('https://**')
            
            authFakeApi(this, apiPrefix)
        },
    })
}